import { LegalFormSelectOptionKeys, Month, RegistrationSteps } from './types'
import { LegalFormTranslations } from './steps/types'

export const ALLOWED_IBAN_COUNTRIES = ['BE', 'FR', 'DE', 'LU', 'NL']

export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_FORMAT_REACT_DATEPICKER = 'dd/MM/yyyy'

export const DAYS_TO_YEARS_COEFFICIENT = 0.002738

export const INITIAL_FLOW = [
  RegistrationSteps.PERSONAL_DATA,
  RegistrationSteps.METER_DETAILS,
  RegistrationSteps.BILLING,
  RegistrationSteps.OVERVIEW,
  RegistrationSteps.CONFIRMATION
]

export const LEGAL_FORM_TRANSLATIONS: Record<LegalFormSelectOptionKeys, LegalFormTranslations> = {
  [LegalFormSelectOptionKeys.BVBA]: {
    nl: 'BVBA',
    en: 'BVBA',
    fr: 'SPRL'
  },
  [LegalFormSelectOptionKeys.BV]: {
    nl: 'BV',
    en: 'BV',
    fr: 'SRL'
  },
  [LegalFormSelectOptionKeys.NV]: {
    nl: 'NV',
    en: 'NV',
    fr: 'SA'
  },
  [LegalFormSelectOptionKeys.GCV]: {
    nl: 'GCV',
    en: 'GCV',
    fr: 'SCS'
  },
  [LegalFormSelectOptionKeys.CVBA]: {
    nl: 'CVBA',
    en: 'CVBA',
    fr: 'SCRL'
  },
  [LegalFormSelectOptionKeys.VZW]: {
    nl: 'VZW',
    en: 'VZW',
    fr: 'ASBL'
  },
  [LegalFormSelectOptionKeys.EBVBA]: {
    nl: 'EBVBA',
    en: 'EBVBA',
    fr: 'SPRLU'
  },
  [LegalFormSelectOptionKeys.VOF]: {
    nl: 'VOF',
    en: 'VOF',
    fr: 'SNC'
  },
  [LegalFormSelectOptionKeys.Eenmanszaak]: {
    nl: 'Eenmanszaak',
    en: 'Eenmanszaak',
    fr: 'Entreprise individuelle'
  }
}

export const MIG_SIX_START = '2021-11-01'
export const MIG_SIX_END = '2021-12-15'

export const MIN_AGE = 18

export const MONTHS: Month[] = [
  {
    i18nKey: 'january',
    defaultValue: 'januari'
  },
  {
    i18nKey: 'february',
    defaultValue: 'februari'
  },
  {
    i18nKey: 'march',
    defaultValue: 'maart'
  },
  {
    i18nKey: 'april',
    defaultValue: 'april'
  },
  {
    i18nKey: 'may',
    defaultValue: 'mei'
  },
  {
    i18nKey: 'june',
    defaultValue: 'juni'
  },
  {
    i18nKey: 'july',
    defaultValue: 'juli'
  },
  {
    i18nKey: 'august',
    defaultValue: 'augustus'
  },
  {
    i18nKey: 'september',
    defaultValue: 'september'
  },
  {
    i18nKey: 'october',
    defaultValue: 'oktober'
  },
  {
    i18nKey: 'november',
    defaultValue: 'november'
  },
  {
    i18nKey: 'december',
    defaultValue: 'december'
  }
]

export const PREFERRED_PHONE_COUNTRIES = ['be', 'nl', 'fr', 'de', 'lu']
